import { useContext } from 'react';
import { ShowAlertDialogContext } from './context';

export const useAlertDialog = () => useContext(ShowAlertDialogContext);
